<template>
  <div class="top-menu">
    <div class="atest">
    <a href="http://www.cursoslefisc.com.br/">
    <img width="175vw" height="30vh" class="logo-menu" src="http://www.cursoslefisc.com.br/certificado/certificado/img/logo_ead.png" alt="lefisc_logo">
    </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      titulo: "",
    }
  }
};
</script>

<style>

.atest {
  display:flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width:100%;
  height: 60px;
  margin: 0 auto;
  background: #fff;
}

.top-menu {  
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #fff;
}

.logo-menu {
  padding-right: 10px;
  flex-grow: 0;
}

.titulo-menu p {
  margin: 0 0 0 10px;
  font-size: 15px;
  font-weight: 700;
  color: #383838;
  flex-grow: 1;
}
</style>